import BaseAPI from "../base";

function getPackagings(cafe_id) {
    return BaseAPI.get(`/nomenculature/packaging/list/${cafe_id}`)
}

function createPackaging(data) {
    return BaseAPI.post(`/nomenculature/packaging/create`, data);
}

function removePackaging(id) {
    return BaseAPI.post(`/nomenculature/packaging/remove/${id}`);
}

function updatePackaging(id, data) {
    return BaseAPI.post(`/nomenculature/packaging/update/${id}`, data);
}

export default {
  getPackagings,
  createPackaging,
  removePackaging,
  updatePackaging,
};